<!-- MODAL ABBONAMENTO -->
<div class="sub-overlay" *ngIf="subUserId" (click)="closeSub()">
  <div class="sub-modal" (click)="$event.stopPropagation()">
    <div class="sub-modal-head">
      <h2 class="sub-modal-title">Abbonamento</h2>
      <p class="sub-modal-sub">{{ getUserById(subUserId)?.name }} {{ getUserById(subUserId)?.lastname }}</p>
    </div>

    <div *ngIf="subLoading" class="sub-loading">Caricamento…</div>

    <ng-container *ngIf="!subLoading && subDetail">
      <!-- Stato -->
      <div class="sub-status-row">
        <span class="sub-badge" [class.paid]="subDetail.subscription.status === 'active'">
          {{ PLAN_LABELS[subDetail.subscription.plan] || subDetail.subscription.plan }}
        </span>
        <span class="sub-state">{{ subDetailStatusLabel() }}</span>
      </div>
      <div class="sub-meta">
        <div *ngIf="subDetail.subscription.trialEndsAt">
          <span>Prova fino al</span><strong>{{ formatDate(subDetail.subscription.trialEndsAt) }}</strong>
        </div>
        <div *ngIf="subDetail.subscription.currentPeriodEnd">
          <span>{{ subDetail.subscription.cancelAtPeriodEnd ? 'Attivo fino al' : 'Rinnovo il' }}</span>
          <strong>{{ formatDate(subDetail.subscription.currentPeriodEnd) }}</strong>
        </div>
        <div *ngIf="subDetail.paymentMethod">
          <span>Metodo</span><strong>{{ subDetail.paymentMethod.brand }} ···· {{ subDetail.paymentMethod.last4 }}</strong>
        </div>
      </div>

      <!-- Pagamenti -->
      <h3 class="sub-section">Pagamenti</h3>
      <div *ngIf="!subDetail.payments.length" class="sub-empty">Nessun pagamento registrato.</div>
      <div *ngIf="subDetail.payments.length" class="sub-payments">
        <div class="sub-pay-row" *ngFor="let p of subDetail.payments">
          <span class="pay-date">{{ formatDate(p.date) }}</span>
          <span class="pay-amount">{{ p.amount | number:'1.2-2' }} {{ p.currency }}</span>
          <span class="pay-status" [class.ok]="p.status === 'paid'">{{ p.status }}</span>
          <a *ngIf="p.url" [href]="p.url" target="_blank" class="pay-link">↗</a>
        </div>
      </div>

      <!-- Azioni -->
      <ng-container *ngIf="canFullAdmin">
        <h3 class="sub-section">Estendi prova</h3>
        <div class="sub-actions">
          <button class="sub-btn" [disabled]="subProcessing" (click)="adminExtendTrial(7)">+7 giorni</button>
          <button class="sub-btn" [disabled]="subProcessing" (click)="adminExtendTrial(30)">+30 giorni</button>
        </div>

        <h3 class="sub-section">Assegna piano (omaggio)</h3>
        <div class="sub-actions">
          <button class="sub-btn" [disabled]="subProcessing" (click)="adminSetPlan('base')">Base</button>
          <button class="sub-btn" [disabled]="subProcessing" (click)="adminSetPlan('pro')">Pro</button>
          <button class="sub-btn" [disabled]="subProcessing" (click)="adminSetPlan('agency')">Agency</button>
          <button class="sub-btn danger" [disabled]="subProcessing" (click)="adminSetPlan('free')">Rimuovi</button>
        </div>
      </ng-container>
    </ng-container>

    <button class="sub-cancel" (click)="closeSub()">Chiudi</button>
  </div>
</div>

<!-- MODAL RUOLO -->
<div class="role-overlay" *ngIf="roleMenuUserId" (click)="roleMenuUserId = null">
  <div class="role-modal" (click)="$event.stopPropagation()">
    <h2 class="role-modal-title">Gestisci ruolo</h2>
    <p class="role-modal-sub">{{ getUserById(roleMenuUserId)?.name }} {{ getUserById(roleMenuUserId)?.lastname }}</p>
    <div class="role-cards">
      <button
        *ngFor="let r of ROLES"
        class="role-card"
        [class.selected]="getUserById(roleMenuUserId)?.role === r.value"
        (click)="applyRole(getUserById(roleMenuUserId), r.value)"
      >
        <span class="role-card-name">{{ r.label }}</span>
        <span class="role-card-desc">{{ r.desc }}</span>
      </button>
    </div>
    <button class="role-cancel" (click)="roleMenuUserId = null">Annulla</button>
  </div>
</div>

<!-- PANNELLO UTENTE (mobile) — fuori da .m-admin: la sua animazione con transform
     romperebbe il position: fixed del pannello -->
<ng-container *ngIf="sheetUser as u">
  <div class="m-sheet-backdrop" (click)="closeUserSheet()"></div>
  <div class="m-sheet">
    <div class="m-sheet-handle"></div>

    <div class="m-sheet-user">
      <span class="m-avatar lg" [class.team]="u.role === 'team_member'">{{ initials(u) }}</span>
      <div class="m-sheet-id">
        <span class="m-sheet-name">{{ u.name }} {{ u.lastname }}</span>
        <span class="m-muted">{{ '@' + u.username }}</span>
      </div>
    </div>

    <div class="m-chips">
      <span
        class="plan-tag"
        [class.trial]="u.subscription?.status === 'trial' && !u.subscription?.trialExpired"
        [class.paid]="u.subscription?.status === 'active'"
        [class.expired]="u.subscription?.status === 'trial' && u.subscription?.trialExpired"
      >{{ subStatusLabel(u.subscription) }}</span>
      <span class="admin-badge" *ngIf="u.role === 'admin'"><app-icon name="zap" [size]="12" /> Admin</span>
      <span class="admin-badge readonly" *ngIf="u.role === 'admin_readonly'"><app-icon name="eye" [size]="12" /> Readonly</span>
      <span class="admin-badge team" *ngIf="u.role === 'team_member'"><app-icon name="users" [size]="12" /> Team</span>
    </div>
    <p class="user-owner" *ngIf="u.owner">Team di {{ u.owner.name }} {{ u.owner.lastname }} ({{ u.owner.email }})</p>

    <dl class="m-sheet-info">
      <div><dt>Email</dt><dd>{{ u.email }}</dd></div>
      <div><dt>Categoria</dt><dd>{{ getActivityLabel(u) }}</dd></div>
      <div><dt>Account</dt><dd>{{ ACCOUNT_STATUS_LABELS[u.status] || u.status }}</dd></div>
      <div><dt>Registrato</dt><dd>{{ formatDate(u.createdAt) }}</dd></div>
      <div><dt>Eventi</dt><dd>{{ u.events }} · {{ u.contracts }} firmati</dd></div>
    </dl>

    <div class="m-sheet-actions">
      <button (click)="openSubscription(u)">
        <app-icon name="card" [size]="17" /> Abbonamento <span class="m-arrow">→</span>
      </button>
      <button *ngIf="canFullAdmin" (click)="toggleRoleMenu(u._id)">
        <app-icon name="shield" [size]="17" /> Gestisci ruolo <span class="m-arrow">→</span>
      </button>
      <ng-container *ngIf="!isReadonly">
        <button (click)="toggleResetInput(u._id)">
          <app-icon name="key" [size]="17" /> Reset password
        </button>
        <div *ngIf="showResetInput[u._id]" class="m-reset">
          <input type="text" [(ngModel)]="resetPasswordMap[u._id]" placeholder="Nuova password (min 6)" />
          <button class="m-btn primary" (click)="resetPassword(u)">Salva</button>
        </div>
        <button (click)="toggleUser(u); closeUserSheet()">
          <app-icon [name]="u.status === 'disabled' ? 'check' : 'x-circle'" [size]="17" />
          {{ u.status === 'disabled' ? 'Riattiva utente' : 'Disabilita utente' }}
        </button>
        <button class="danger" (click)="deleteUser(u); closeUserSheet()">
          <app-icon name="trash" [size]="17" /> Elimina utente
        </button>
      </ng-container>
    </div>

    <button class="m-sheet-close" (click)="closeUserSheet()">Chiudi</button>
  </div>
</ng-container>

<!-- ============================================================= -->
<!-- VISTA DESKTOP                                                  -->
<!-- ============================================================= -->
<div class="container d-admin">
  <!-- HEADER -->
  <div class="page-header">
    <div>
      <h1 class="page-title">Admin <em>Panel</em></h1>
      <p class="page-subtitle">Gestione utenti e statistiche</p>
    </div>
  </div>

  <!-- TABS -->
  <div class="tabs">
    <button *ngIf="!isRoadmap" [class.active]="activeTab === 'stats'" (click)="activeTab = 'stats'">Statistiche</button>
    <button *ngIf="!isStats && !isRoadmap" [class.active]="activeTab === 'users'" (click)="activeTab = 'users'">Utenti</button>
    <button *ngIf="!isStats && !isSupport && !isRoadmap" [class.active]="activeTab === 'feedback'" (click)="activeTab = 'feedback'">Feedback Beta</button>
    <button *ngIf="canFullAdmin" [class.active]="activeTab === 'news'" (click)="openNews()">Novità app</button>
    <button *ngIf="canFullAdmin" [class.active]="activeTab === 'waitlist'" (click)="openWaitlist()">Lista d'attesa</button>
    <button [class.active]="activeTab === 'roadmap'" (click)="openRoadmap()">Roadmap</button>
  </div>

  <!-- ===== TAB STATS ===== -->
  <div *ngIf="activeTab === 'stats'">
    <div *ngIf="!stats" class="stats-loading">Caricamento...</div>

    <div *ngIf="stats">

      <!-- ROW 1 — KPI principali -->
      <div class="kpi-row">

        <!-- Utenti -->
        <div class="kpi-card kpi-large">
          <span class="kpi-label">Utenti totali</span>
          <span class="kpi-value">{{ stats.totalUsers }}</span>
          <div class="kpi-breakdown">
            <div class="breakdown-bar">
              <div class="breakdown-seg seg-active"   [style.flex]="stats.activeUsers"></div>
              <div class="breakdown-seg seg-pending"  [style.flex]="stats.pendingUsers"></div>
              <div class="breakdown-seg seg-disabled" [style.flex]="stats.disabledUsers"></div>
            </div>
            <div class="breakdown-legend">
              <span class="leg-dot active"></span><span>{{ stats.activeUsers }} attivi</span>
              <span class="leg-dot pending"></span><span>{{ stats.pendingUsers }} in attesa</span>
              <span class="leg-dot disabled"></span><span>{{ stats.disabledUsers }} disabilitati</span>
            </div>
          </div>
        </div>

        <!-- Nuovi utenti -->
        <div class="kpi-card">
          <span class="kpi-label">Nuovi utenti</span>
          <span class="kpi-value gold">{{ stats.newUsers }}</span>
          <span class="kpi-sub">negli ultimi 30 giorni</span>
        </div>

        <!-- Eventi -->
        <div class="kpi-card">
          <span class="kpi-label">Eventi creati</span>
          <span class="kpi-value">{{ stats.totalEvents }}</span>
          <span class="kpi-sub">totale storico</span>
        </div>

        <!-- Contratti firmati -->
        <div class="kpi-card">
          <span class="kpi-label">Contratti firmati</span>
          <span class="kpi-value">{{ stats.totalContracts }}</span>
          <div class="kpi-rate" *ngIf="stats.totalEvents">
            <div class="rate-bar">
              <div class="rate-fill" [style.width.%]="signedPercent"></div>
            </div>
            <span class="rate-label">{{ signedPercent }}% degli eventi</span>
          </div>
        </div>

      </div>

      <!-- ROW — Abbonamenti -->
      <div class="kpi-row" *ngIf="stats.subscriptions">
        <div class="kpi-card kpi-large">
          <span class="kpi-label">MRR stimato</span>
          <span class="kpi-value gold">{{ stats.subscriptions.mrr | number:'1.2-2' }} €</span>
          <span class="kpi-sub">{{ stats.subscriptions.activePaying }} abbonati paganti</span>
        </div>

        <div class="kpi-card">
          <span class="kpi-label">In prova</span>
          <span class="kpi-value">{{ stats.subscriptions.trial }}</span>
          <span class="kpi-sub">utenti in trial</span>
        </div>

        <div class="kpi-card">
          <span class="kpi-label">Conversione</span>
          <span class="kpi-value">{{ stats.subscriptions.conversionRate }}%</span>
          <span class="kpi-sub">trial → pagante</span>
        </div>

        <div class="kpi-card">
          <span class="kpi-label">Abbonati per piano</span>
          <div class="plan-dist">
            <div><span class="plan-dot base"></span>Base <strong>{{ stats.subscriptions.activeByPlan.base }}</strong></div>
            <div><span class="plan-dot pro"></span>Pro <strong>{{ stats.subscriptions.activeByPlan.pro }}</strong></div>
            <div><span class="plan-dot agency"></span>Agency <strong>{{ stats.subscriptions.activeByPlan.agency }}</strong></div>
          </div>
        </div>
      </div>

      <!-- Vendita abbonamenti (toggle beta) -->
      <div class="config-card">
        <div class="config-info">
          <p class="config-title">Vendita abbonamenti</p>
          <p class="config-desc">
            {{ checkoutEnabled
              ? 'Attiva: gli utenti possono acquistare i piani da soli.'
              : 'Disattivata (beta): gli utenti inviano richieste, i piani li assegni tu.' }}
          </p>
        </div>
        <button
          class="toggle-switch"
          [class.on]="checkoutEnabled"
          [disabled]="togglingCheckout || !canFullAdmin"
          (click)="toggleCheckout()"
        >
          <span class="toggle-knob"></span>
        </button>
      </div>

      <!-- Richieste attivazione -->
      <div class="chart-card" *ngIf="pendingRequests.length">
        <h3 class="section-title">
          Richieste attivazione
          <span class="req-count">{{ pendingRequests.length }}</span>
        </h3>
        <div class="req-list">
          <div class="req-row" *ngFor="let r of pendingRequests">
            <div class="req-main">
              <span class="req-plan" [class]="'plan-' + r.plan">{{ PLAN_LABELS[r.plan] || r.plan }}</span>
              <div class="req-user">
                <span class="req-name">{{ r.user?.name }} {{ r.user?.lastname }}</span>
                <span class="req-email">{{ r.user?.email }}</span>
              </div>
              <span class="req-date">{{ formatDate(r.createdAt) }}</span>
            </div>
            <p class="req-message" *ngIf="r.message">“{{ r.message }}”</p>
            <div class="req-actions" *ngIf="canFullAdmin">
              <button class="req-btn approve" (click)="approveRequest(r)">Approva</button>
              <button class="req-btn dismiss" (click)="dismissRequest(r)">Ignora</button>
            </div>
          </div>
        </div>
      </div>

      <!-- ROW 2 — Grafico mensile -->
      <div class="chart-card" *ngIf="stats.eventsByMonth?.length > 0">
        <h3 class="section-title">Nuovi eventi per mese</h3>
        <div class="chart">
          <div *ngFor="let m of stats.eventsByMonth" class="bar-wrap">
            <span class="bar-value">{{ m.count }}</span>
            <div class="bar-track"><div class="bar" [style.height.%]="barHeight(m.count)"></div></div>
            <span class="bar-label">{{ monthLabel(m) }}</span>
          </div>
        </div>
      </div>

    </div>
  </div>

  <!-- ===== TAB USERS ===== -->
  <div *ngIf="activeTab === 'users'">
    <!-- Toolbar -->
    <div class="toolbar">
      <input
        type="text"
        [(ngModel)]="searchQuery"
        (ngModelChange)="applyFilters()"
        placeholder="Cerca per nome, username, email..."
        class="search-input"
      />
      <!-- Toolbar filtri — SOSTITUISCI il blocco filter-btns -->
      <div class="filter-btns">
        <button
          [class.active]="filterStatus === 'all'"
          (click)="filterStatus = 'all'; applyFilters()"
        >
          Tutti
        </button>
        <button
          [class.active]="filterStatus === 'active'"
          (click)="filterStatus = 'active'; applyFilters()"
        >
          Attivi
        </button>
        <button
          [class.active]="filterStatus === 'pending'"
          (click)="filterStatus = 'pending'; applyFilters()"
        >
          In attesa
        </button>
        <button
          [class.active]="filterStatus === 'disabled'"
          (click)="filterStatus = 'disabled'; applyFilters()"
        >
          Disabilitati
        </button>
      </div>
    </div>

    <!-- Contatore -->
    <p class="count-label">{{ filteredUsers.length }} utenti</p>

    <!-- Tabella -->
    <div class="table-wrap">
      <table class="user-table">
        <thead>
          <tr>
            <th>Utente</th>
            <th>Email</th>
            <th>Categoria</th>
            <th>Stato</th>
            <th>Registrato</th>
            <th class="text-center">Eventi</th>
            <th class="text-center">Firmati</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let user of filteredUsers">
            <td>
              <div class="user-cell">
                <div class="user-name-line">
                  <span class="user-name">{{ user.name }} {{ user.lastname }}</span>
                  <span class="admin-badge" *ngIf="user.role === 'admin'"><app-icon name="zap" [size]="12" /> Admin</span>
                  <span class="admin-badge readonly" *ngIf="user.role === 'admin_readonly'"><app-icon name="eye" [size]="12" /> Readonly</span>
                  <span class="admin-badge team" *ngIf="user.role === 'team_member'"><app-icon name="users" [size]="12" /> Team</span>
                </div>
                <span class="user-username">{{ '@' + user.username }}</span>
                <span class="user-owner" *ngIf="user.owner">
                  Team di {{ user.owner.name }} {{ user.owner.lastname }} ({{ user.owner.email }})
                </span>
              </div>
            </td>
            <td class="text-mid" data-label="Email">{{ user.email }}</td>
            <td data-label="Categoria"><span class="activity-tag">{{ getActivityLabel(user) }}</span></td>
            <td data-label="Stato">
              <span
                class="plan-tag"
                [class.trial]="user.subscription?.status === 'trial' && !user.subscription?.trialExpired"
                [class.paid]="user.subscription?.status === 'active'"
                [class.expired]="user.subscription?.status === 'trial' && user.subscription?.trialExpired"
              >
                {{ subStatusLabel(user.subscription) }}
              </span>
            </td>
            <td class="text-mid" data-label="Registrato">{{ formatDate(user.createdAt) }}</td>
            <td class="text-center" data-label="Eventi">{{ user.events }}</td>
            <td class="text-center" data-label="Firmati">{{ user.contracts }}</td>

            <!-- Menu ⋯ -->
            <td class="action-cell">
              <button class="menu-btn" (click)="toggleMenu(user._id, $event); $event.stopPropagation()">⋯</button>
              <div class="action-menu"
                   *ngIf="openMenuId === user._id"
                   [style.top.px]="menuTop"
                   [style.right.px]="menuRight">
                <div class="menu-header">{{ user.name }} {{ user.lastname }}</div>
                <ng-container *ngIf="!isReadonly">
                  <button (click)="toggleUser(user); closeMenu()">
                    {{ user.status === 'disabled' ? '✓ Riattiva' : '⊘ Disabilita' }}
                  </button>
                  <button (click)="toggleResetInput(user._id)">
                    <app-icon name="key" [size]="15" /> Reset password
                  </button>
                </ng-container>
                <button *ngIf="canFullAdmin" (click)="toggleRoleMenu(user._id)">
                  <app-icon name="shield" [size]="15" /> Gestisci ruolo
                </button>
                <button (click)="openSubscription(user)">
                  <app-icon name="card" [size]="15" /> Abbonamento
                </button>
                <ng-container *ngIf="!isReadonly">
                  <div class="menu-divider"></div>
                  <button class="menu-danger" (click)="deleteUser(user); closeMenu()">
                    <app-icon name="trash" [size]="15" /> Elimina utente
                  </button>
                </ng-container>
              </div>

              <!-- Reset password inline -->
              <div *ngIf="showResetInput[user._id]" class="reset-input-wrap">
                <input
                  type="text"
                  [(ngModel)]="resetPasswordMap[user._id]"
                  placeholder="Nuova password"
                  class="reset-input"
                />
                <button class="reset-confirm-btn" (click)="resetPassword(user)">Salva</button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <!-- ===== TAB FEEDBACK ===== -->
  <div *ngIf="activeTab === 'feedback'">
    <!-- STATS RAPIDE -->
    <div class="stats-grid" style="margin-bottom: 1.5rem">
      <div class="stat-card">
        <span class="stat-label">Feedback ricevuti</span>
        <span class="stat-value">{{ feedbacks.length }}</span>
      </div>
      <div class="stat-card">
        <span class="stat-label">NPS medio</span>
        <span class="stat-value gold">{{ avgNps() }}</span>
      </div>
      <div class="stat-card">
        <span class="stat-label">Interessati abbonamento</span>
        <span class="stat-value active">{{ interestedCount() }}</span>
      </div>
      <div class="stat-card">
        <span class="stat-label">Non interessati</span>
        <span class="stat-value pending">{{
          feedbacks.length - interestedCount()
        }}</span>
      </div>
    </div>

    <!-- LISTA FEEDBACK -->
    <div class="feedback-list">
      <div *ngFor="let f of feedbacks" class="feedback-item">
        <div class="feedback-item-header">
          <div class="feedback-meta">
            <span class="feedback-date">{{ formatDate(f.createdAt) }}</span>
            <span class="feedback-user">{{ f.user_id }}</span>
          </div>
          <div class="feedback-scores">
            <span
              class="nps-pill"
              [class.nps-high]="f.nps >= 8"
              [class.nps-mid]="f.nps >= 5 && f.nps < 8"
              [class.nps-low]="f.nps < 5"
            >
              NPS {{ f.nps }}
            </span>
            <span
              class="sub-pill"
              [class.sub-yes]="f.interested_subscription"
              [class.sub-no]="!f.interested_subscription"
            >
              {{
                f.interested_subscription
                  ? "Vuole abbonamento"
                  : "Non interessata"
              }}
            </span>
            <span *ngIf="f.price_range" class="price-pill">{{
              f.price_range
            }}</span>
          </div>
        </div>

        <div *ngIf="f.useful_features?.length" class="feedback-features">
          <span *ngFor="let feat of f.useful_features" class="feat-chip">{{
            feat
          }}</span>
        </div>

        <div *ngIf="f.missing_features" class="feedback-missing">
          <span class="missing-label">Cosa manca:</span>
          <p>{{ f.missing_features }}</p>
        </div>
      </div>

      <p *ngIf="!feedbacks.length" class="no-data">
        Nessun feedback ricevuto ancora.
      </p>
    </div>
  </div>

  <!-- ===== TAB LISTA D'ATTESA ===== -->
  <div *ngIf="activeTab === 'waitlist'">
    <p class="count-label">{{ waitlist.length }} iscrizioni</p>
    <div class="table-wrap">
      <table class="user-table">
        <thead>
          <tr>
            <th>Email</th>
            <th>Professione</th>
            <th>Lingua</th>
            <th>Data</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let w of waitlist">
            <td>{{ w.email }}</td>
            <td>{{ w.profession || "-" }}</td>
            <td>{{ w.lang }}</td>
            <td>{{ formatDate(w.createdAt) }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <p *ngIf="!waitlist.length" class="no-data">Nessuna iscrizione ancora.</p>
  </div>

  <!-- ===== TAB NOVITÀ APP ===== -->
  <div *ngIf="activeTab === 'news'">
    <ng-container *ngTemplateOutlet="newsPanel"></ng-container>
  </div>

  <!-- ===== TAB ROADMAP ===== -->
  <div *ngIf="activeTab === 'roadmap'">
    <ng-container *ngTemplateOutlet="roadmapPanel"></ng-container>
  </div>
</div>

<!-- ============================================================= -->
<!-- VISTA MOBILE — griglia sezioni + card + pannelli dal basso     -->
<!-- ============================================================= -->
<section class="m-admin">
  <!-- ===== HUB ===== -->
  <ng-container *ngIf="!mobileSection">
    <header class="m-head">
      <h1 class="m-title">Admin <em>Panel</em></h1>
      <p class="m-sub">Gestione utenti e statistiche</p>
    </header>

    <div class="m-kpis" *ngIf="stats">
      <div class="m-kpi">
        <span class="m-kpi-value">{{ stats.totalUsers }}</span>
        <span class="m-kpi-label">Utenti</span>
      </div>
      <div class="m-kpi m-kpi-rose">
        <span class="m-kpi-value">+{{ stats.newUsers }}</span>
        <span class="m-kpi-label">Ultimi 30 gg</span>
      </div>
      <div class="m-kpi m-kpi-green" *ngIf="stats.subscriptions; else kpiEvents">
        <span class="m-kpi-value">{{ stats.subscriptions.mrr | number:'1.0-0' }} €</span>
        <span class="m-kpi-label">MRR stimato</span>
      </div>
      <ng-template #kpiEvents>
        <div class="m-kpi m-kpi-green">
          <span class="m-kpi-value">{{ stats.totalEvents }}</span>
          <span class="m-kpi-label">Eventi</span>
        </div>
      </ng-template>
    </div>

    <button class="m-alert" *ngIf="pendingRequests.length" (click)="openMobileSection('stats')">
      <span class="m-alert-icon"><app-icon name="bell" [size]="18" /></span>
      <span class="m-alert-text">
        <b>{{ pendingRequests.length }}</b>
        {{ pendingRequests.length === 1 ? 'richiesta di attivazione' : 'richieste di attivazione' }}
      </span>
      <span class="m-arrow">→</span>
    </button>

    <div class="m-tiles">
      <button *ngFor="let s of mobileSections" class="m-tile" (click)="openMobileSection(s.key)">
        <span class="m-tile-icon" [class.accent]="s.accent"><app-icon [name]="s.icon" [size]="20" /></span>
        <span class="m-tile-label">{{ s.label }}</span>
        <span class="m-tile-hint">{{ sectionHint(s.key) }}</span>
      </button>
    </div>
  </ng-container>

  <!-- ===== SEZIONE ===== -->
  <ng-container *ngIf="mobileSection">
    <header class="m-section-head">
      <button class="m-back" *ngIf="mobileSections.length > 1" (click)="closeMobileSection()">← Admin</button>
      <h1 class="m-title">{{ sectionLabel(mobileSection) }}</h1>
    </header>

    <!-- STATISTICHE -->
    <ng-container *ngIf="mobileSection === 'stats'">
      <p *ngIf="!stats" class="m-empty">Caricamento…</p>
      <ng-container *ngIf="stats">
        <div class="m-card">
          <div class="m-card-row">
            <span class="m-card-label">Utenti totali</span>
            <span class="m-big">{{ stats.totalUsers }}</span>
          </div>
          <div class="breakdown-bar">
            <div class="breakdown-seg seg-active"   [style.flex]="stats.activeUsers"></div>
            <div class="breakdown-seg seg-pending"  [style.flex]="stats.pendingUsers"></div>
            <div class="breakdown-seg seg-disabled" [style.flex]="stats.disabledUsers"></div>
          </div>
          <div class="m-legend">
            <span><span class="leg-dot active"></span>{{ stats.activeUsers }} attivi</span>
            <span><span class="leg-dot pending"></span>{{ stats.pendingUsers }} in attesa</span>
            <span><span class="leg-dot disabled"></span>{{ stats.disabledUsers }} disabilitati</span>
          </div>
        </div>

        <div class="m-grid">
          <div class="m-stat">
            <span class="m-stat-value gold">{{ stats.newUsers }}</span>
            <span class="m-stat-label">Nuovi utenti<br />ultimi 30 giorni</span>
          </div>
          <div class="m-stat">
            <span class="m-stat-value">{{ stats.totalEvents }}</span>
            <span class="m-stat-label">Eventi creati<br />totale storico</span>
          </div>
          <div class="m-stat m-stat-wide">
            <div class="m-card-row">
              <span class="m-stat-label">Contratti firmati</span>
              <span class="m-stat-value">{{ stats.totalContracts }}</span>
            </div>
            <div class="rate-bar" *ngIf="stats.totalEvents">
              <div class="rate-fill" [style.width.%]="signedPercent"></div>
            </div>
            <span class="m-stat-label" *ngIf="stats.totalEvents">{{ signedPercent }}% degli eventi</span>
          </div>
        </div>

        <ng-container *ngIf="stats.subscriptions">
          <h2 class="m-h2">Abbonamenti</h2>
          <div class="m-grid">
            <div class="m-stat m-stat-wide m-stat-hero">
              <span class="m-stat-label">MRR stimato</span>
              <span class="m-stat-value gold">{{ stats.subscriptions.mrr | number:'1.2-2' }} €</span>
              <span class="m-stat-label">{{ stats.subscriptions.activePaying }} abbonati paganti</span>
            </div>
            <div class="m-stat">
              <span class="m-stat-value">{{ stats.subscriptions.trial }}</span>
              <span class="m-stat-label">In prova</span>
            </div>
            <div class="m-stat">
              <span class="m-stat-value">{{ stats.subscriptions.conversionRate }}%</span>
              <span class="m-stat-label">Conversione<br />trial → pagante</span>
            </div>
            <div class="m-stat m-stat-wide">
              <span class="m-stat-label">Abbonati per piano</span>
              <div class="plan-dist">
                <div><span class="plan-dot base"></span>Base <strong>{{ stats.subscriptions.activeByPlan.base }}</strong></div>
                <div><span class="plan-dot pro"></span>Pro <strong>{{ stats.subscriptions.activeByPlan.pro }}</strong></div>
                <div><span class="plan-dot agency"></span>Agency <strong>{{ stats.subscriptions.activeByPlan.agency }}</strong></div>
              </div>
            </div>
          </div>
        </ng-container>

        <div class="m-card m-config">
          <div class="m-config-info">
            <span class="m-config-title">Vendita abbonamenti</span>
            <span class="m-config-desc">
              {{ checkoutEnabled ? 'Attiva: gli utenti acquistano da soli.' : 'Disattivata: i piani li assegni tu.' }}
            </span>
          </div>
          <button
            class="toggle-switch"
            [class.on]="checkoutEnabled"
            [disabled]="togglingCheckout || !canFullAdmin"
            (click)="toggleCheckout()"
          >
            <span class="toggle-knob"></span>
          </button>
        </div>

        <ng-container *ngIf="pendingRequests.length">
          <h2 class="m-h2">Richieste attivazione <span class="req-count">{{ pendingRequests.length }}</span></h2>
          <div class="m-list">
            <div class="m-card m-req" *ngFor="let r of pendingRequests">
              <div class="m-card-row">
                <span class="m-req-name">{{ r.user?.name }} {{ r.user?.lastname }}</span>
                <span class="req-plan">{{ PLAN_LABELS[r.plan] || r.plan }}</span>
              </div>
              <span class="m-muted">{{ r.user?.email }} · {{ formatDate(r.createdAt) }}</span>
              <p class="m-quote" *ngIf="r.message">“{{ r.message }}”</p>
              <div class="m-btn-row" *ngIf="canFullAdmin">
                <button class="m-btn primary" (click)="approveRequest(r)">Approva</button>
                <button class="m-btn" (click)="dismissRequest(r)">Ignora</button>
              </div>
            </div>
          </div>
        </ng-container>

        <ng-container *ngIf="stats.eventsByMonth?.length > 0">
          <h2 class="m-h2">Nuovi eventi per mese</h2>
          <div class="m-card m-chart-card">
            <div class="chart m-chart">
              <div *ngFor="let m of stats.eventsByMonth" class="bar-wrap">
                <span class="bar-value">{{ m.count }}</span>
                <div class="bar-track"><div class="bar" [style.height.%]="barHeight(m.count)"></div></div>
                <span class="bar-label">{{ monthLabel(m) }}</span>
              </div>
            </div>
          </div>
        </ng-container>
      </ng-container>
    </ng-container>

    <!-- UTENTI -->
    <ng-container *ngIf="mobileSection === 'users'">
      <div class="m-search">
        <app-icon name="search" [size]="16" />
        <input
          type="search"
          [(ngModel)]="searchQuery"
          (ngModelChange)="applyFilters()"
          placeholder="Cerca nome, username, email…"
        />
      </div>
      <div class="m-pills">
        <button [class.active]="filterStatus === 'all'" (click)="setFilterStatus('all')">Tutti</button>
        <button [class.active]="filterStatus === 'active'" (click)="setFilterStatus('active')">Attivi</button>
        <button [class.active]="filterStatus === 'pending'" (click)="setFilterStatus('pending')">In attesa</button>
        <button [class.active]="filterStatus === 'disabled'" (click)="setFilterStatus('disabled')">Disabilitati</button>
      </div>
      <p class="m-count">{{ filteredUsers.length }} utenti</p>

      <div class="m-list">
        <button
          *ngFor="let user of filteredUsers"
          class="m-user"
          [class.disabled]="user.status === 'disabled'"
          (click)="openUserSheet(user)"
        >
          <span class="m-avatar" [class.team]="user.role === 'team_member'">{{ initials(user) }}</span>
          <span class="m-user-info">
            <span class="m-user-name">
              {{ user.name }} {{ user.lastname }}
              <app-icon *ngIf="user.role === 'admin'" name="zap" [size]="12" class="m-role-icon" />
              <app-icon *ngIf="user.role === 'admin_readonly'" name="eye" [size]="12" class="m-role-icon" />
            </span>
            <span class="m-user-mail">{{ user.email }}</span>
            <span class="m-user-meta">{{ user.events }} eventi · {{ user.contracts }} firmati</span>
          </span>
          <span
            class="plan-tag"
            [class.trial]="user.subscription?.status === 'trial' && !user.subscription?.trialExpired"
            [class.paid]="user.subscription?.status === 'active'"
            [class.expired]="user.subscription?.status === 'trial' && user.subscription?.trialExpired"
          >{{ subStatusLabel(user.subscription) }}</span>
        </button>
      </div>
      <p *ngIf="!filteredUsers.length" class="m-empty">Nessun utente trovato.</p>
    </ng-container>

    <!-- FEEDBACK -->
    <ng-container *ngIf="mobileSection === 'feedback'">
      <div class="m-grid">
        <div class="m-stat">
          <span class="m-stat-value">{{ feedbacks.length }}</span>
          <span class="m-stat-label">Feedback ricevuti</span>
        </div>
        <div class="m-stat">
          <span class="m-stat-value gold">{{ avgNps() }}</span>
          <span class="m-stat-label">NPS medio</span>
        </div>
        <div class="m-stat">
          <span class="m-stat-value">{{ interestedCount() }}</span>
          <span class="m-stat-label">Interessati abbonamento</span>
        </div>
        <div class="m-stat">
          <span class="m-stat-value">{{ feedbacks.length - interestedCount() }}</span>
          <span class="m-stat-label">Non interessati</span>
        </div>
      </div>

      <div class="m-list">
        <div *ngFor="let f of feedbacks" class="m-card m-feedback">
          <div class="m-card-row">
            <span class="m-muted">{{ formatDate(f.createdAt) }}</span>
            <span
              class="nps-pill"
              [class.nps-high]="f.nps >= 8"
              [class.nps-mid]="f.nps >= 5 && f.nps < 8"
              [class.nps-low]="f.nps < 5"
            >NPS {{ f.nps }}</span>
          </div>
          <div class="m-chips">
            <span class="sub-pill" [class.sub-yes]="f.interested_subscription" [class.sub-no]="!f.interested_subscription">
              {{ f.interested_subscription ? 'Vuole abbonamento' : 'Non interessata' }}
            </span>
            <span *ngIf="f.price_range" class="price-pill">{{ f.price_range }}</span>
          </div>
          <div *ngIf="f.useful_features?.length" class="m-chips">
            <span *ngFor="let feat of f.useful_features" class="feat-chip">{{ feat }}</span>
          </div>
          <div *ngIf="f.missing_features" class="m-missing">
            <span class="m-missing-label">Cosa manca</span>
            <p>{{ f.missing_features }}</p>
          </div>
        </div>
      </div>
      <p *ngIf="!feedbacks.length" class="m-empty">Nessun feedback ricevuto ancora.</p>
    </ng-container>

    <!-- LISTA D'ATTESA -->
    <ng-container *ngIf="mobileSection === 'waitlist'">
      <p class="m-count">{{ waitlist.length }} iscrizioni</p>
      <div class="m-list">
        <div *ngFor="let w of waitlist" class="m-card m-wait">
          <span class="m-wait-mail">{{ w.email }}</span>
          <span class="m-muted">
            {{ w.profession || 'Professione non indicata' }} · {{ w.lang | uppercase }} · {{ formatDate(w.createdAt) }}
          </span>
        </div>
      </div>
      <p *ngIf="!waitlist.length" class="m-empty">Nessuna iscrizione ancora.</p>
    </ng-container>

    <!-- NOVITÀ APP -->
    <div *ngIf="mobileSection === 'news'" class="m-news">
      <ng-container *ngTemplateOutlet="newsPanel"></ng-container>
    </div>

    <!-- ROADMAP -->
    <div *ngIf="mobileSection === 'roadmap'" class="m-roadmap">
      <ng-container *ngTemplateOutlet="roadmapPanel"></ng-container>
    </div>
  </ng-container>
</section>

<!-- Contenuto condiviso desktop/mobile -->
<ng-template #newsPanel>
  <div class="news-panel">
    <div class="news-recipients">
      <span class="stat-label">Destinatari (hanno attivato "Novità app")</span>
      <span class="stat-value gold">{{ newsRecipientCount === null ? '…' : newsRecipientCount }}</span>
    </div>

    <h3 class="news-version">Anteprima — v{{ latestChangelog.version }} <span class="news-date">{{ latestChangelog.date }}</span></h3>

    <div class="news-preview">
      <ng-container *ngFor="let sec of latestChangelog.sections">
        <p class="news-section-label">{{ sec.label }}</p>
        <ul class="news-items">
          <li *ngFor="let item of sec.items">{{ item }}</li>
        </ul>
      </ng-container>
    </div>

    <p class="news-hint">
      L'email viene inviata solo agli utenti che hanno attivato la notifica "Novità app" nelle impostazioni.
      Il contenuto è la versione più recente del changelog.
    </p>

    <button
      class="news-send-btn"
      (click)="sendAppNews()"
      [disabled]="isSendingNews || !newsRecipientCount"
    >
      {{ isSendingNews ? 'Invio in corso…' : 'Invia a ' + (newsRecipientCount ?? 0) + ' utenti' }}
    </button>
  </div>
</ng-template>

<ng-template #roadmapPanel>
  <div class="rm-toolbar">
    <div class="rm-counts">
      <span class="rm-count todo">Da fare {{ roadmapCountsView.todo }}</span>
      <span class="rm-count doing">In corso {{ roadmapCountsView.doing }}</span>
      <span class="rm-count done">Fatto {{ roadmapCountsView.done }}</span>
    </div>
    <div class="rm-filters">
      <button [class.active]="roadmapFilter === 'all'" (click)="setRoadmapFilter('all')">Tutte</button>
      <button [class.active]="roadmapFilter === 'todo'" (click)="setRoadmapFilter('todo')">Da fare</button>
      <button [class.active]="roadmapFilter === 'doing'" (click)="setRoadmapFilter('doing')">In corso</button>
      <button [class.active]="roadmapFilter === 'done'" (click)="setRoadmapFilter('done')">Fatto</button>
    </div>
    <button *ngIf="canWriteRoadmap" class="rm-add-btn" (click)="showNewRoadmap = !showNewRoadmap">
      {{ showNewRoadmap ? 'Annulla' : '+ Nuova voce' }}
    </button>
  </div>

  <div *ngIf="showNewRoadmap && canWriteRoadmap" class="rm-new">
    <input class="rm-input" [(ngModel)]="newRoadmap.title" placeholder="Titolo" />
    <input class="rm-input" [(ngModel)]="newRoadmap.category" placeholder="Categoria" />
    <select class="rm-select" [(ngModel)]="newRoadmap.priority">
      <option *ngFor="let p of ROADMAP_PRIORITIES" [value]="p.value">{{ p.label }}</option>
    </select>
    <textarea class="rm-input rm-textarea" [(ngModel)]="newRoadmap.description" placeholder="Descrizione (opzionale)"></textarea>
    <button class="rm-save-btn" (click)="addRoadmapItem()" [disabled]="!newRoadmap.title">Aggiungi</button>
  </div>

  <p *ngIf="!roadmap.length" class="rm-empty">Nessuna voce in roadmap.</p>

  <div *ngFor="let group of roadmapGroupsView; trackBy: trackRoadmapGroup" class="rm-group">
    <h3 class="rm-group-title">{{ group.category }}</h3>

    <div *ngFor="let item of group.items; trackBy: trackRoadmapItem" class="rm-item" [class.done]="item.status === 'done'">
      <!-- Vista compatta -->
      <ng-container *ngIf="editingRoadmapId !== item._id">
        <div class="rm-item-main" (click)="startEditRoadmap(item)">
          <span class="rm-prio" [class.alta]="item.priority === 'alta'" [class.media]="item.priority === 'media'" [class.bassa]="item.priority === 'bassa'">{{ priorityLabel(item.priority) }}</span>
          <span class="rm-texts">
            <span class="rm-title">{{ item.title }}</span>
            <span *ngIf="item.description" class="rm-desc">{{ item.description }}</span>
          </span>
        </div>
        <div class="rm-item-actions">
          <select class="rm-status-select" [class.doing]="item.status === 'doing'" [class.done]="item.status === 'done'"
            [ngModel]="item.status" (ngModelChange)="setRoadmapStatus(item, $event)" [disabled]="!canWriteRoadmap">
            <option *ngFor="let s of ROADMAP_STATUSES" [value]="s.value">{{ s.label }}</option>
          </select>
          <button *ngIf="canWriteRoadmap" class="rm-del-btn" (click)="deleteRoadmapItem(item)"><app-icon name="trash" [size]="15" /></button>
        </div>
      </ng-container>

      <!-- Vista modifica -->
      <div *ngIf="editingRoadmapId === item._id" class="rm-edit">
        <input class="rm-input" [(ngModel)]="roadmapDraft.title" placeholder="Titolo" />
        <input class="rm-input" [(ngModel)]="roadmapDraft.category" placeholder="Categoria" />
        <div class="rm-edit-row">
          <select class="rm-select" [(ngModel)]="roadmapDraft.status">
            <option *ngFor="let s of ROADMAP_STATUSES" [value]="s.value">{{ s.label }}</option>
          </select>
          <select class="rm-select" [(ngModel)]="roadmapDraft.priority">
            <option *ngFor="let p of ROADMAP_PRIORITIES" [value]="p.value">{{ p.label }}</option>
          </select>
        </div>
        <textarea class="rm-input rm-textarea" [(ngModel)]="roadmapDraft.description" placeholder="Descrizione (opzionale)"></textarea>
        <div class="rm-edit-actions">
          <button class="rm-save-btn" (click)="saveEditRoadmap()">Salva</button>
          <button class="rm-cancel-btn" (click)="cancelEditRoadmap()">Annulla</button>
        </div>
      </div>
    </div>
  </div>
</ng-template>
